module.exports = ".scrolling-wrapper{\r\n\toverflow-x: auto;\r\n}"